export default "__VITE_ASSET__GmZ8Rr_N__"